/**
 * Loading placeholders shaped like the bubble they replace, so the thread does not
 * jump when real messages land.
 */

import { cn } from "cn";
import { Skeleton } from "@/components/ui/skeleton";

export function ChannelMessageSkeleton() {
  return (
    <>
      <DaySeparatorSkeleton />
      <MessageBubbleSkeleton />
      <DaySeparatorSkeleton />
      <MessageBubbleSkeleton blockRows={1} />
      <MessageBubbleSkeleton blockRows={3} />
      <MessageBubbleSkeleton />
    </>
  );
}

export function ChannelMessageSkeletonLoadMore() {
  return (
    <>
      <MessageBubbleSkeleton />
      <MessageBubbleSkeleton />
      <MessageBubbleSkeleton />
    </>
  );
}

function DaySeparatorSkeleton() {
  return (
    <div
      className={cn(
        /* sorted */
        "relative flex",
        "items-center justify-center",
        "w-full h-11",
      )}
    >
      <div className="flex h-px grow bg-bg-dark-min" />
      <div className="px-4">
        <Skeleton className="w-16 h-5" />
      </div>
      <div className="flex h-px grow bg-bg-dark-min" />
    </div>
  );
}

function MessageBubbleSkeleton({ blockRows }: { blockRows?: number }) {
  return (
    <div className="flex gap-3 px-3 py-3 xl:px-4">
      <Skeleton className="size-8 rounded-full shrink-0" />
      <div className="grow">
        <div className="flex items-center gap-1 mb-1">
          <Skeleton className="w-20 h-5 rounded" />
          <Skeleton className="w-12 h-4 rounded" />
        </div>
        <Skeleton className="w-full h-5.5 rounded" />

        {!!blockRows && (
          <div className="divide-y divide-border-dark-min mt-3 border border-border-dark-min rounded-lg">
            {Array.from({ length: blockRows }).map((_, index) => (
              <div
                // biome-ignore lint/suspicious/noArrayIndexKey: placeholder rows have no identity
                key={index}
                className="flex items-center gap-2 p-4"
              >
                <Skeleton className="size-5 rounded-full" />
                <Skeleton className="w-38 h-5 rounded" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
